import * as React from "react";
import { Pagination, Stack } from "@mui/material";

import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import { IXCategoryFilterProps } from "../../../../utils/interfaces/containers/XCategoryFilter.interfaces";
import { IArticleData } from "../../../../utils/interfaces/common/XArticle.interfaces";

import GridSorter from "./GridSorter";
import GridArticleList from "./GridArticleList";

const GridSide: React.FC<
  IXCategoryFilterProps & {
    onChange: (args: TSetUrlParamsArgs) => Promise<void>;
    urlParams: TSetUrlParamsArgs;
    articles?: IArticleData[];
    articlesCount?: number;
    setOpenFilter: (open: boolean) => void;
  }
> = ({ articlesCount = 0, pageLimit = 8, ...props }) => {
  const pageCount = Math.ceil(articlesCount / pageLimit);

  return (
    <Stack flex={1} spacing={2}>
      <GridSorter
        {...props}
        articlesCount={articlesCount}
        pageLimit={pageLimit}
        pageCount={pageCount}
      />
      <GridArticleList {...props} pageLimit={pageLimit} />
      {pageCount > 1 && (
        <Pagination
          page={props.urlParams.p ?? 1}
          count={pageCount}
          onChange={async (_, _page) => {
            await props.onChange({ p: _page });
          }}
        />
      )}
    </Stack>
  );
};

export default GridSide;
